import React from 'react';

import PagesIcon from '@material-ui/icons/Pages';

import {
  PERMISSAO_TELA_VENDAS_LISTAR,
  PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR,
  PERMISSAO_TELA_RATOEIRA_LISTAR,
  PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR,
  PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR,
  PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuVendas = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Vendas"
    icon={<PagesIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_VENDAS_LISTAR] && hasResource('vendas')}
    {permissoes[PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR] &&
      hasResource('devolucoes_vendas')}
    {permissoes[PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR] &&
      hasResource('pre_vendas')}
    {permissoes[PERMISSAO_TELA_RATOEIRA_LISTAR] && hasResource('ratoeira')}
    {permissoes[PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR] &&
      hasResource('creditos_devolucoes')}
    {permissoes[PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR] &&
      hasResource('pedidos_liberacao_precos')}
    {permissoes[PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR] &&
      hasResource('solicitacoes_liberacao_precos')}
    {permissoes[PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR] &&
      hasResource('descarrego_mercadorias')}
  </SubMenu>
);

export default SubMenuVendas;
